<template lang="pug">
    .member-tabs(v-if="enabled")
        tabs(:items="tabs" :active-tab="$route.fullPath" @click="activateTab")
        slot
    .full-height-error(v-else)
        Error(:message="null" :code="403")
</template>

<i18n>
{
    "de": {
        "Members": "Mitglieder",
        "Customers": "Kunden",
        "Customer Groups": "Kundengruppen"
    }
}
</i18n>

<script>

import { useSetupStore } from '@/stores'
import Tabs from '@/components/Tabs'
import Error from '@/components/Error'

export default {
    name: 'MemberTabs',
    components: {
        Tabs,
        Error
    },
    computed: {
        primaryLabel() {
            return this.enabledExtensions.includes('shop')
                ? this.$t('Customers')
                : this.$t('Members')
        },
        tabs() {
            const tabs = [
                {
                    name: this.primaryLabel,
                    path: '/members',
                    icon: {
                        name: 'user-friends',
                        group: 'fas'
                    }
                },
            ]

            if (this.enabledExtensions.includes('shop')) {
                tabs.push({
                    name: this.$t('Customer Groups'),
                    path: '/people/customer-groups',
                    icon: {
                        name: 'users',
                        group: 'fas'
                    }
                })
            }

            return tabs
        },
        enabled() {
            return this.enabledExtensions.includes('restricted-area')
                || this.enabledExtensions.includes('shop')
        },
        enabledExtensions() {
            return useSetupStore().enabledExtensions;
        },
        setupStore() {
            return useSetupStore();
        }
    },
    methods: {
        activateTab(item) {
            return this.setupStore.activateTab(item);
        },
    }
}
</script>
